<template>
	<div class="newborn">
		<h3 class="qjc-fts-16 qjc-c-dark qjc-ftw-500">新生儿信息</h3>
		
		<el-form
			:model="formData"
			:rules="rules"
			inline
			:hide-required-asterisk="true"
			ref="newbornForm"
		>
			<el-form-item
				label="妈妈的生育年龄："
				prop="mage"
			>
				<el-input
					v-model="formData.mage"
					placeholder="请输入"
				></el-input>
				岁
			</el-form-item>
			
			<el-form-item
				label="宝宝的出生孕周："
				prop="week"
			>
				<el-input
					v-model="formData.week"
					placeholder="请输入"
				></el-input>
				周
			</el-form-item>
			
			<el-form-item
				label="宝宝的出生体重："
				prop="bweight"
			>
				<el-input
					v-model="formData.bweight"
					placeholder="请输入"
				></el-input>
				g
			</el-form-item>
			
			<el-form-item
				label="宝宝的性别："
				prop="bsex"
			>
				<el-select
					v-model="formData.bsex"
				>
					<el-option
						label="男"
						:value="1"
					></el-option>
					<el-option
						label="女"
						:value="2"
					></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item
				label="APGAR分数——即新生儿评分(第一分钟)："
				prop="aps1"
				class="apgar"
			>
				<el-input
					v-model="formData.aps1"
					placeholder="请输入"
				></el-input>
				分
			</el-form-item>
			
		</el-form>
		
		<el-button @click="next" class="next qjc-fts-16 qjc-ftw-500">下一步</el-button>
		
	</div>
</template>

<script>
	export default{
		name: 'newborn',
		data() {
			var apgarVerify = (rule, value, callback) => {
				if(value < 0 || value > 10){
					callback(new Error('APGAR分数——即新生儿评分(第一分钟)为0~10'));
				}else{
					callback();
				}
			}
			
			return {
				rules: {
					bsex: [
						{ required: true, message: '请选择入宝宝性别', trigger: 'change' }
					],
					mage: [
						{ required: true, message: '请输入妈妈的生育年龄', trigger: 'blur' }
					],
					week: [
						{ required: true, message: '请输入宝宝的出生孕周：', trigger: 'blur' }
					],
					bweight: [
						{ required: true, message: '请输入宝宝的出生体重：', trigger: 'blur' }
					],
					aps1: [
						{ required: true, message: '请输入APGAR分数——即新生儿评分(第一分钟)', trigger: 'blur' },
						{ validator: apgarVerify, trigger: 'blur' }
					],
				}
			}
		},
		props: ['formData'],
		methods: {
			next() {
				this.$refs.newbornForm.validate((isSuc) => {
					if(isSuc){
						this.$emit('checkTab', 'Puerpera');
					}
				});
			}
		}
	}
</script>

<style scoped>
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-form-item__label{
		font-size: 0.14rem;
	}
	.el-form .el-input >>> input,
	.el-select >>> .el-input__inner{
		width: 2rem;
		height: 0.32rem;
		font-size: 0.14rem;
		line-height: 0.14rem;
		padding: 0.09rem 0.16rem;
	}
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-form-item__label{
		vertical-align: middle;
	}
	.el-form >>> .el-form-item__label{
		min-width: 1.14rem;
		line-height: 0.32rem;
		text-align: left;
		padding-right: 0;
	}
</style>
<style lang="scss" scoped>
	.newborn{
		padding-top: 0.32rem;
		
		.el-form{
			margin-top: 0.14rem;
			
			.el-form-item{
				margin-right: 0.72rem;
				margin-bottom: 0.16rem;
				
				&.apgar{
					margin-left: 0.2rem;
				}
				
				&:nth-child(3n){
					margin-right: 0;
				}
				
				.el-input{
					width: auto;
				}
			}
		}
		
		.next{
			display: block;
			width: 2rem;
			height: 0.48rem;
			line-height: 0.48rem;
			margin: 0.6rem auto 0;
		}
	}
</style>
